import { ConsentContext } from "./provider.js";
import React from "react";
export const ConsentInternalApiContext = React.createContext({});
ConsentInternalApiContext.displayName = "ConsentInternalApiContext";
export const InternalApiProvider = ({ api, children }) => {
    const { consent, processes, setGrants } = React.useContext(ConsentContext);
    const [draftGrants, setDraftGrants] = React.useState(consent.grants);
    const internalApi = api ?? {
        addGrant: (grant) => setDraftGrants((curr) => (curr.includes(grant) ? curr : [...curr, grant])),
        addGroup: (group) => {
            const groupProcesses = processes.filter(({ group: groupId }) => group.id === groupId);
            const arrayUniqueByKey = (array, key) => [
                ...new Map(array.map((item) => [item[key], item])).values(),
            ];
            setDraftGrants((curr) => {
                const result = arrayUniqueByKey([...curr, ...groupProcesses.map(({ id }) => ({ id }))], "id");
                return result;
            });
        },
        discard: () => setDraftGrants(consent.grants),
        hasGrant: (grant) => draftGrants.some(({ id }) => grant.id === id),
        removeGrant: (grant) => setDraftGrants((curr) => curr.filter(({ id }) => grant.id !== id)),
        removeGroup: (group) => setDraftGrants((curr) => {
            const groupProcessIds = processes
                .filter(({ group: groupId }) => group.id === groupId)
                .map(({ id }) => id);
            return curr.filter(({ id }) => !groupProcessIds.includes(id));
        }),
        save: (grants) => setGrants(grants ?? draftGrants),
        grants: draftGrants,
    };
    return (React.createElement(ConsentInternalApiContext.Provider, { value: internalApi }, children));
};
//# sourceMappingURL=internal-api.js.map